import React from "react"

export const useWindowSize = () => {
  const [size, setSize] = React.useState([0, 0])
  React.useLayoutEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener("resize", updateSize)
    updateSize()
    return () => window.removeEventListener("resize", updateSize)
  }, [])
  return { width: size[0], height: size[1] }
}

export const useOnScreen = (ref, direction?: "HORIZONTAL" | "VERTICAL") => {
  const [isOnScreen, setIsOnScreen] = React.useState(false)
  const observerRef = React.useRef<IntersectionObserver>(null)

  React.useEffect(() => {
    const rootMargin = !direction
      ? "0px"
      : direction === "HORIZONTAL"
      ? "100% 0px 100% 0px"
      : "0px 100% 0px 100%"
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        setIsOnScreen(entry.isIntersecting)
      },
      {
        root: null,
        rootMargin,
        threshold: 1.0,
      }
    )
  }, [])

  React.useEffect(() => {
    observerRef.current.observe(ref.current)

    return () => {
      observerRef.current.disconnect()
    }
  }, [ref])

  return isOnScreen
}
